import React from 'react';
import { Route, Switch } from 'react-router';
import ViewPlacements from './view';
import EditPlacements from './edit';
import CreatePlacements from './create';

const Placements = () => {
  return (
    <Switch>
      <Route exact path='/admin/placements' component={ViewPlacements} />
      <Route exact path='/admin/placements/new' component={CreatePlacements} />
      <Route exact path='/admin/placements/:id' component={EditPlacements} />
    </Switch>
  );
};

export default Placements;
